import React from "react";

import NoPermission from "src/@core/components/NoPermission";
import useFinancePermissions from "src/hooks/useFinancePermissions";

const FinancePermissionGuard = ({ moduleKey, requireEdit = false, children }) => {
  const { canView, canEdit } = useFinancePermissions();

  const allowed = requireEdit ? canEdit(moduleKey) : canView(moduleKey);

  if (allowed) {
    return <>{children}</>;
  }

  return <NoPermission />;
};

export default FinancePermissionGuard;

